import React, { useState } from 'react';

import Loader from 'react-loader-spinner';
import { useList } from '../../hooks/listHook';
import EmptyList from '../../useful/EmptyList';
import { withAuthorization } from '../../session';
import PremiumUserItem from './PremiumUserItem';
import PremiumUserForm from './PremiumUserForm';
import ModalInfo from '../../useful/ModalInfo';

const PremiumUser = (props) => {

    const { loading, list } = useList(props.firebase.premiumUserList(), null)
    const [modal, setModal] = useState({ show: false, title: '', message: '' });

    const showModal = (title, message) => {
        setModal({ show: true, title, message });
    }

    const tableHead =
        <thead className="">
            <tr >
                <th className="border-top-0" style={{ width: 40 }}></th>
                <th className="border-top-0 pl-0" >USUARIO</th>
                <th className="border-top-0 text-center" style={{ width: 25.5 }}>
                    <span>TORNEOS</span>
                </th>
                <th className="border-top-0" style={{ width: 40 }}></th>
            </tr>
        </thead>

    const listView = (list && list.length > 0) ?
        list.map((item, i) => {
            return (
                <PremiumUserItem key={i} user={item} showModal={showModal} />
            )
        })
        :
        <tr>
            <td colSpan={6}>
                <EmptyList />
            </td>
        </tr>

    return (
        <div>
            <div className="mb-3">
                <PremiumUserForm showModal={showModal} />
            </div>

            <div className="bg-white border rounded-lg p-2">
                {/* <h6 className="font-weight-bolder">Listado de usuarios</h6> */}

                {(!loading) ?
                    <table className="table table-sm small ">
                        {tableHead}
                        <tbody>
                            {listView}
                        </tbody>
                    </table>
                    :
                    <div className="nav justify-content-center row">
                        <Loader className="mt-4"
                            type="ThreeDots"
                            color="#263238"
                            height={60}
                            width={60}
                            timeout={0} />
                    </div>
                }

            </div>

            <ModalInfo
                data={modal}
                onClose={() => setModal({ show: false, title: '', message: '' })}
            />

        </div>
    )


}

const condition = authUser => {
    if (!!authUser) {
        return authUser.token.admin === true;
    } else
        return false;
};
export default withAuthorization(condition)(PremiumUser);